<template>
  <div class="register">
    <div class="content">
      <div class="register__row">
        <RegisterSteps
          v-if="!hideLeft"
          :step="step"
          :title="'Регистрация'"
          :stepList="stepList"
        />
        <RegisterForm :skipPhone="skipPhone" :dataFromSnaplogic="dataFromSnaplogic" @changeStep="changeStep" @realStep="changeRealStep"/>
      </div>
    </div>
  </div>
</template>

<script>
import RegisterForm from "../../components/auth/RegisterForm.vue";
import RegisterSteps from "../../components/auth/RegisterSteps.vue";

export default {
  metaInfo: {
    title: "Регистрация",
  },
  name: "Register",
  props: {
    dataFromSnaplogic: [Object, String],
    skipPhone: Boolean
  },
  data: () => ({
    step: 1,
    hideLeft: false,
    realStep: 1,
    stepList: [
      "Шаг 1. Номер телефона",
      "Шаг 2. Email",
      "Шаг 3. Личные данные",
      "Шаг 4. Место работы",
    ],
  }),
  methods: {
    changeRealStep(realStep) {
      this.realStep = realStep
    },
    changeStep(stepNumber, hideLeft ) {
      if (hideLeft) {
        this.hideLeft = true;
      }
      this.step = stepNumber;
      
    },
  },
  mounted() {
  
  },
  components: { RegisterSteps, RegisterForm },
};
</script>

<style lang="scss" scoped>
.register {
  height: 100%;
  padding: 64px 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-grow: 1;
  min-height: inherit;
  @media screen and (max-width: 1220px) {
    padding: 40px 0;
    height: auto;
  }
  &__row {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;

    @media screen and (max-width: 1220px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__text {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #3c4242;

    & a {
      color: #830051;
      text-decoration: underline;
    }
  }

  & .content {
    height: 100%;
  }
}
</style>